module.exports = __webpack_public_path__ + "img/電気回路_3_9_1.8aa982e2.png";